__turbopack_context__.v({
  "googleBtn": "GoogleLoginButton-module__i7-kJq__googleBtn",
});
